module.exports = __webpack_public_path__ + "img/imgl.f474409d.png";